import { render, staticRenderFns } from "./BucketListItemForm.vue?vue&type=template&id=ad7a7046&scoped=true&"
import script from "./BucketListItemForm.vue?vue&type=script&lang=js&"
export * from "./BucketListItemForm.vue?vue&type=script&lang=js&"
import style0 from "./BucketListItemForm.vue?vue&type=style&index=0&id=ad7a7046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7a7046",
  null
  
)

export default component.exports